import { Id } from 'src/types'

export interface InitialValuesPartnerProps {
  active: boolean
  additional_info: string
  address_number: string
  address: string
  city_id: string
  country_id: string
  description: string
  latitude: number
  longitude: number
  partner_description: string
  partner_id: Id
  partner_name: string
  partner_number: number
  partner_type: string
  partner_vat_number: string
  quarter: string
  state_id: string
  zip_code: string
}

export interface InitialValuesHotelProps {
  category_stars: number
  hotel_class: string
  hotel_image_url: string
  information: string
  laundry: boolean
  nights: number
  parking: boolean
  partner_hotel_number: number
  pool: boolean
  refundable: boolean
  restaurant: boolean
}

export function getInitialValuesPartner(
  partner: any
): InitialValuesPartnerProps {
  return {
    active: partner?.status || true,
    additional_info: partner?.additional_info || '',
    address_number: partner?.address_number || '',
    address: partner?.address || '',
    city_id: '',
    country_id: '',
    description: '',
    latitude: +partner?.latitude || null,
    longitude: +partner?.longitude || null,
    partner_description: partner?.partner_description || '',
    partner_id: partner?.id || null,
    partner_name: partner?.partner_name || '',
    partner_number: partner?.partner_number || null,
    partner_type: 'HOTEL',
    partner_vat_number: partner?.partner_vat_number || '',
    quarter: partner?.quarter || '',
    state_id: '',
    zip_code: partner?.zip_code || ''
  }
}

export function getInitialValuesHotel(partner: any): InitialValuesHotelProps {
  return {
    category_stars: partner?.partner_hotels?.[0]?.category_stars || 0,
    hotel_class: partner?.partner_hotels?.[0]?.hotel_class || null,
    hotel_image_url: partner?.partner_hotels?.[0]?.hotel_image_url || '',
    information: partner?.partner_hotels?.[0]?.information || '',
    laundry: partner?.partner_hotels?.[0]?.laundry || false,
    nights: partner?.partner_hotels?.[0]?.nights || 0,
    parking: partner?.partner_hotels?.[0]?.parking || false,
    partner_hotel_number:
      partner?.partner_hotels?.[0]?.partner_hotel_number || null,
    pool: partner?.partner_hotels?.[0]?.pool || false,
    refundable: partner?.partner_hotels?.[0]?.refundable || false,
    restaurant: partner?.partner_hotels?.[0]?.restaurant || false
  }
}
